import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Form } from 'react-bootstrap';
const EditTask = ({ modal, toggle, update, taskObj, index }) => {
    const [task, setTask] = useState({
        name: '',
        description: ''
    })



    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(task)
        update(task)
        
    }

    

    useEffect(() => {
        setTask((old) => ({ ...old, name: taskObj.name, description: taskObj.description }))
    }, [])
    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Update A task</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Task name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Task1"
                            autoFocus
                            name="name"
                            value={task.name}
                            onChange={(e) => setTask({ ...task, name: e.target.value })}

                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Task Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Task1"
                            autoFocus
                            type="text"
                            name="description"
                            value={task.description}
                            onChange={(e) => setTask({ ...task, description:e.target.value })}

                        />
                    </Form.Group>
                    
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                            Close
                        </Button>
                        <Button color="primary" type='submit'>
                            Update
                        </Button>
                    </ModalFooter>
                </Form>
            </ModalBody>


        </Modal>
    )
}

export default EditTask